import { createQuery } from '@tanstack/svelte-query';
import { fetchUsers } from '$lib/api/user';
import type { AdminUser } from '$lib/types/user';

export const usersQueryKey = ['users'] as const;

export function usersQueryOptions() {
	return {
		queryKey: usersQueryKey,
		queryFn: () => fetchUsers()
	};
}

export const usersQuery = () => createQuery<Array<AdminUser>>(() => usersQueryOptions());
